import get from 'lodash/get';
import {
    DEFAULT_ASSIGNEE_FIELDS,
    DEFAULT_CLASSIFICATION_NUMBER_FIELDS,
    DEFAULT_KEYWORD_FIELDS,
    DEFAULT_OTHER_FIELDS,
    LOGIC_OPERATOR_AND,
    LOGIC_OPERATOR_NOT,
    LOGIC_OPERATOR_OR,
} from '../../constants';
import searchFieldsService from '../service/searchFieldsService';

export const SEARCH_FIELDS = [
    {
        name: 'CITE_CATEGORY',
        value: 'CITE_CATEGORY:()',
        labelPlaceholder: '',
        desc: {
            cn: '引用类别',
            tw: '引用類別',
            de: 'Citation/Rejection Category',
            en: 'Citation/Rejection Category',
            jp: '引用タイプ',
        },
    },
    {
        name: 'E_PRIORITY_DATE',
        value: 'E_PRIORITY_DATE:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            cn: '最早优先权日',
            tw: '最早優先權日',
            de: 'Earliest Priority Date',
            en: 'Earliest Priority Date',
            jp: '最先の優先権主張日',
        },
    },
    {
        name: 'F_PBD',
        value: 'F_PBD:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            cn: '首次公开日',
            tw: '首次公開日',
            de: 'First Publication Date',
            en: 'First Publication Date',
            jp: '最初公開日',
        },
    },
    {
        name: 'PRIORITY_COUNTRY_COUNT',
        value: 'PRIORITY_COUNTRY_COUNT:[ TO *]',
        labelPlaceholder: '',
        desc: {
            cn: '优先权国家/地区个数',
            de: 'Priority Country/Region Count',
            en: 'Priority Country/Region Count',
            jp: '優先権主張国・地域の数',
            tw: '優先權國家/地區個數',
        },
    },
    {
        name: 'PRIORITY_EMPTY',
        value: 'PRIORITY_EMPTY:()',
        labelPlaceholder: '',
        desc: {
            cn: '所有无优先权专利',
            de: 'Patents without priority',
            en: 'Patents without priority',
            jp: 'すべての優先権なし特許',
            tw: '所有無優先權專利',
        },
    },
    {
        name: 'SEP',
        value: 'SEP:()',
        labelPlaceholder: '',
        desc: {
            cn: '所有标准专利',
            de: 'Patente mit SEP',
            en: 'Patents with SEP',
            jp: '全ての標準必須特許',
            tw: '所有標準專利',
        },
    },
    {
        name: 'SEP_NUMBER',
        value: 'SEP_NUMBER:()',
        labelPlaceholder: '',
        desc: {
            cn: '标准号',
            de: 'SEP-Nummer',
            en: 'SEP Number',
            jp: 'SEP標準番号',
            tw: '標準號',
        },
    },
    {
        name: 'SEP_PROJECT',
        value: 'SEP_PROJECT:()',
        labelPlaceholder: '',
        desc: {
            cn: '标准-项目',
            de: 'SEP-Projekt',
            en: 'SEP Project',
            jp: 'SEP標準プロジェクト',
            tw: '標準-項目',
        },
    },
    {
        name: 'AWARD_NAME',
        value: 'AWARD_NAME:()',
        labelPlaceholder: '',
        desc: {
            cn: '奖励名称',
            de: 'Award Name',
            en: 'Award Name',
            jp: '賞名',
            tw: '獎勵名稱',
        },
    },
    {
        name: 'AWARD_LEVEL',
        value: 'AWARD_LEVEL:()',
        labelPlaceholder: '',
        desc: {
            cn: '奖励等级',
            de: 'Auszeichnungsstufe',
            en: 'Award Level',
            jp: '受賞等級',
            tw: '獎勵等級',
        },
    },
    {
        name: 'AWARD_SESSION',
        value: 'AWARD_SESSION:()',
        labelPlaceholder: '',
        desc: {
            cn: '奖励届次',
            de: 'Preisverleihung',
            en: 'Award Session',
            jp: '受賞回次',
            tw: '獎勵屆次',
        },
    },
    {
        name: 'F_AN',
        value: 'F_AN:()',
        labelPlaceholder: '',
        desc: {
            cn: '第一原始申请(专利权)人',
            de: 'Erster ursprünglicher Beauftragter',
            en: 'First Original Assignee',
            jp: '筆頭出願人(権利者)',
            tw: '第壹原始申請(專利權)人',
        },
    },
    {
        name: 'IN_COUNT',
        value: 'IN_COUNT:[ TO *]',
        labelPlaceholder: '',
        desc: {
            cn: '发明人数量',
            de: 'Anzahl der Erfinder',
            en: 'Count of Inventors',
            jp: '発明者数',
            tw: '發明人數量',
        },
    },
    {
        name: 'CPC_ALL',
        value: 'CPC_ALL:()',
        labelPlaceholder: '',
        desc: {
            cn: '官方/预测CPC分类号',
            de: 'Official/Predicted CPC',
            en: 'Official/Predicted CPC',
            jp: '公式/予測CPCコード',
            tw: '官方/預測CPC分類號',
        },
    },
    {
        name: 'CPC_COUNT',
        value: 'CPC_COUNT:[ TO *]',
        labelPlaceholder: '',
        desc: {
            cn: 'CPC分类数量',
            de: 'Anzahl der CPC',
            en: 'Count of CPC',
            jp: 'CPC分類数',
            tw: 'CPC分類數量',
        },
    },
    {
        name: 'IPC_COUNT',
        value: 'IPC_COUNT:[ TO *]',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC分类数量',
            de: 'Anzahl der IPC',
            en: 'Count of IPC',
            jp: 'IPC分類数',
            tw: 'IPC分類數量',
        },
    },
    {
        name: 'MCPC',
        value: 'MCPC:()',
        labelPlaceholder: '',
        desc: {
            cn: 'CPC主分类号',
            de: 'Haupt-CPC',
            en: 'Main CPC',
            jp: '主CPC',
            tw: 'CPC主分類號',
        },
    },
    {
        name: 'CPC_GROUP',
        value: 'CPC_GROUP:()',
        labelPlaceholder: '',
        desc: {
            cn: 'CPC分类号大组',
            de: 'CPC Group',
            en: 'CPC Group',
            jp: 'CPCメイングループ記号',
            tw: 'CPC分類號大組',
        },
    },
    {
        name: 'CPC_SUB_GROUP',
        value: 'CPC_SUB_GROUP:()',
        labelPlaceholder: '',
        desc: {
            cn: 'CPC分类号小组',
            de: 'CPC Sub Group',
            en: 'CPC Sub Group',
            jp: 'CPCサブグループ',
            tw: 'CPC分類號小組',
        },
    },
    {
        name: 'IPC_CPC',
        value: 'IPC_CPC:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC/CPC',
            de: 'IPC & CPC',
            en: 'IPC & CPC',
            jp: 'IPC/CPC',
            tw: 'IPC/CPC',
        },
    },
    {
        name: 'SUB_CASE',
        value: 'SUB_CASE:()',
        labelPlaceholder: '',
        desc: {
            cn: '分案',
            de: 'Divisional',
            en: 'Divisional',
            jp: '分割出願',
            tw: '分案',
        },
    },
    {
        name: 'LEGAL_STATUS_DATE',
        value: 'LEGAL_STATUS_DATE:[ TO 2020]',
        labelPlaceholder: '',
        desc: {
            cn: '法律状态更新日',
            de: 'Datum des rechtlichen Status',
            en: 'Legal Status Date',
            jp: 'リーガルステータス更新日',
            tw: '法律狀態更新日',
        },
    },
    {
        name: 'INVALID_COUNT',
        value: 'INVALID_COUNT:()',
        labelPlaceholder: '',
        desc: {
            cn: '无效次数',
            de: 'Ungültige Anzahl',
            en: 'Invalid Count',
            jp: '無効審判回数',
            tw: '無效次數',
        },
    },
    {
        name: 'LITIGATION_COUNT',
        value: 'LITIGATION_COUNT:()',
        labelPlaceholder: '',
        desc: {
            cn: '诉讼次数',
            de: 'Anzahl der Rechtsstreitigkeiten',
            en: 'Litigation Count',
            jp: '訴訟回数',
            tw: '訴訟次數',
        },
    },
    {
        name: 'LICENSE_COUNT',
        value: 'LICENSE_COUNT:()',
        labelPlaceholder: '',
        desc: {
            cn: '许可次数',
            de: 'Anzahl der Lizenzen',
            en: 'Licensing Count',
            jp: '許可回数',
            tw: '許可次數',
        },
    },
    {
        name: 'PLEDGE_COUNT',
        value: 'PLEDGE_COUNT:()',
        labelPlaceholder: '',
        desc: {
            cn: '质押次数',
            de: 'Anzahl der Zusagen',
            en: 'Pledge Count',
            jp: '質権回数',
            tw: '質押次數',
        },
    },
    {
        name: 'TRANSFER',
        value: 'TRANSFER:()',
        labelPlaceholder: '',
        desc: {
            cn: '所有发生转让的专利',
            de: 'Patente mit Zuweisungsinformationen',
            en: 'Patents with assignment information',
            jp: '譲渡情報付きの全ての特許',
            tw: '所有發生轉讓的專利',
        },
    },
    {
        name: 'TRANS_EFDT',
        value: 'TRANS_EFDT:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            cn: '权利转移生效日',
            de: 'Datum des Inkrafttretens der Abtretung',
            en: 'Effective Date of Assignment',
            jp: '権利譲渡の効力発生日',
            tw: '權利轉移生效日',
        },
    },
    {
        name: 'TRANSFER_BEFORE',
        value: 'TRANSFER_BEFORE:()',
        labelPlaceholder: '',
        desc: {
            cn: '转让人',
            de: 'Zuweiser',
            en: 'Assignor',
            jp: '譲渡人',
            tw: '轉讓人',
        },
    },
    {
        name: 'TRANSFER_AFTER',
        value: 'TRANSFER_AFTER:()',
        labelPlaceholder: '',
        desc: {
            cn: '受让人',
            de: 'Übernehmer',
            en: 'Assignee',
            jp: '譲受人',
            tw: '受讓人',
        },
    },
    {
        name: 'IPC_SECTION',
        value: 'IPC_SECTION:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC分类号部',
            de: 'IPC-Sektion',
            en: 'IPC Section',
            jp: 'IPCセクション',
            tw: 'IPC分類號部',
        },
    },
    {
        name: 'IPC_CLASS',
        value: 'IPC_CLASS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC分类号大类',
            de: 'IPC-Klasse',
            en: 'IPC Class',
            jp: 'IPCクラス',
            tw: 'IPC分類號大類',
        },
    },
    {
        name: 'IPC_SUB_CLASS',
        value: 'IPC_SUB_CLASS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC分类号小类',
            de: 'IPC-Unterklasse',
            en: 'IPC Sub Class',
            jp: 'IPCサブクラス',
            tw: 'IPC分類號小類',
        },
    },
    {
        name: 'MIPC_SECTION',
        value: 'MIPC_SECTION:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC主分类号部',
            de: 'IPC-Hauptabschnitt',
            en: 'Main IPC Section',
            jp: '主IPCセクション',
            tw: 'IPC主分類號部',
        },
    },
    {
        name: 'MIPC_CLASS',
        value: 'MIPC_CLASS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC主分类号大类',
            de: 'Haupt-IPC-Klasse',
            en: 'Main IPC Class',
            jp: '主IPCクラス',
            tw: 'IPC主分類號大類',
        },
    },
    {
        name: 'MIPC_SUB_CLASS',
        value: 'MIPC_SUB_CLASS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC主分类号小类',
            de: 'Haupt-IPC-Unterklasse',
            en: 'Main IPC Sub Class',
            jp: '主IPCサブクラス',
            tw: 'IPC主分類號小類',
        },
    },
    {
        name: 'CPC_SECTION',
        value: 'CPC_SECTION:()',
        labelPlaceholder: '',
        desc: {
            cn: 'CPC分类号部',
            de: 'CPC-Abschnitt',
            en: 'CPC Section',
            jp: 'CPCセクション',
            tw: 'CPC分類號部',
        },
    },
    {
        name: 'CPC_CLASS',
        value: 'CPC_CLASS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'CPC分类号大类',
            de: 'CPC-Klasse',
            en: 'CPC Class',
            jp: 'CPCクラス',
            tw: 'CPC分類號大類',
        },
    },
    {
        name: 'CPC_SUB_CLASS',
        value: 'CPC_SUB_CLASS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'CPC分类号小类',
            de: 'CPC-Unterklasse',
            en: 'CPC Sub Class',
            jp: 'CPCサブクラス',
            tw: 'CPC分類號小類',
        },
    },
    {
        name: 'GBC_SECTION',
        value: 'GBC_SECTION:()',
        labelPlaceholder: '',
        desc: {
            cn: '国民经济行业分类门类',
            de: 'GBC-Sektion',
            en: 'GBC Section',
            jp: '国民経済産業分類のセクション',
            tw: '國民經濟行業分類門類',
        },
    },

    {
        name: 'NEV',
        value: 'NEV:()',
        labelPlaceholder: '',
        desc: {
            cn: '新能源汽车行业分类',
            en: 'New Energy Vehicle',
            jp: '新エネルギー自動車業界の分類',
            tw: '新能源汽車行業分類',
        },
    },

    {
        name: 'AN_ADD',
        value: 'AN_ADD:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Assignee Address',
            cn: '原始申请(专利权)人地址',
            tw: '原始申請(專利權)人地址',
            jp: '出願人(権利者)の住所',
            de: 'Ursprüngliche Empfängeradresse',
        },
    },
    {
        name: 'AN_COUNTRY',
        value: 'AN_COUNTRY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Assignee Region',
            cn: '原始申请(专利权)人区域',
            tw: '原始申請(專利權)人區域',
            jp: '出願人(権利者)の国別',
            de: 'Ursprüngliche Empfängerregion',
        },
    },
    {
        name: 'AN_PROVINCE',
        value: 'AN_PROVINCE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Assignee State/Province',
            cn: '原始申请(专利权)人州/省',
            tw: '原始申請(專利權)人州/省',
            jp: '出願人(権利者)の州/省',
            de: 'Ursprünglicher Empfänger Bundesstaat / Provinz',
        },
    },
    {
        name: 'ALL_AN',
        value: 'ALL_AN:()',
        labelPlaceholder: '',
        desc: {
            en: 'All Assignees',
            cn: '[全字段]申请(专利权)人',
            tw: '[全字段]申請(專利權)人',
            jp: '[全体]出願人(権利者)',
            de: 'Anmeldung (Patent) gemeinsamer Index',
        },
    },
    {
        name: 'ANCS',
        value: 'ANCS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Std. Current Assignee',
            cn: '[标]当前申请(专利权)人',
            tw: '[標]當前申請(專利權)人',
            jp: '[標準]現出願人(権利者)',
            de: 'Standardisierter gegenwärtiger Beauftragter',
        },
    },
    {
        name: 'ANCS_EXACT',
        value: 'ANCS_EXACT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Exact Std. Current Assignee',
            cn: '精准[标]当前申请(专利权)人',
            tw: '精准[標]當前申請(專利權)人',
            jp: '[標準]現出願人(権利者)(完全一致)',
            de: 'Genaue Std. Aktueller Beauftragter',
        },
    },
    {
        name: 'ANC',
        value: 'ANC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Assignee',
            cn: '当前申请(专利权)人',
            tw: '當前申請(專利權)人',
            jp: '現出願人(権利者)',
            de: 'Aktueller Beauftragter',
        },
    },
    {
        name: 'ANS',
        value: 'ANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Std. Original Assignee (Applicant)',
            cn: '[标]原始申请(专利权)人',
            tw: '[標]原始申請(專利權)人',
            jp: '[標準]出願人(権利者)',
            de: 'Standardisierter ursprünglicher Rechtsnachfolger (Antragsteller)',
        },
    },
    {
        name: 'ANS_EXACT',
        value: 'ANS_EXACT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Exact Std. Original Assignee (Applicant)',
            cn: '精准[标]原始申请(专利权)人',
            tw: '精準[標]原始申請(專利權)人',
            jp: '[標準]出願人(権利者)(完全一致)',
            de: 'Genaue Person der ursprünglichen Anmeldung (Patentrecht)',
        },
    },
    {
        name: 'MAINF',
        value: 'MAINF:()',
        labelPlaceholder: '',
        desc: {
            en: 'Main Field',
            cn: '主要字段',
            tw: '主要字段',
            jp: '主なフィールド',
            de: 'Main Field',
        },
    },
    {
        name: 'MAINF_ALL',
        value: 'MAINF_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Main Field And Translation',
            cn: '主要字段原文和翻译',
            tw: '主要字段原文和翻譯',
            jp: '主なフィールドの原文と訳文',
            de: 'Original Main Field And Translation',
        },
    },
    {
        name: 'AN',
        value: 'AN:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Assignee (Applicant)',
            cn: '原始申请(专利权)人',
            tw: '原始申請(專利權)人',
            jp: '出願人(権利者)',
            de: 'ursprünglicher Rechtsnachfolger (Anmelder)',
        },
    },
    {
        name: 'TAC',
        value: 'TAC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Title/Abstract/Claims',
            cn: '标题/摘要/权利要求',
            tw: '標題/摘要/權利要求',
            jp: '名称/要約/請求項',
            de: 'Titel/Abstract/Ansprüche',
        },
    },
    {
        name: 'PN',
        value: 'PN:()',
        labelPlaceholder: '',
        desc: {
            en: 'Publication Number',
            cn: '公开(公告)号',
            tw: '公開(公告)號',
            jp: '公開(公告)番号',
            de: 'Publikationsnummer',
        },
    },
    {
        name: 'IPC',
        value: 'IPC:()',
        labelPlaceholder: '',
        desc: {
            en: 'IPC',
            cn: 'IPC分类号',
            tw: 'IPC分類號',
            jp: 'IPC分類',
            de: 'Internationale Patent Klassifikation',
        },
    },
    {
        name: 'TA',
        value: 'TA:()',
        labelPlaceholder: '',
        desc: {
            en: 'Title/Abstract',
            cn: '标题/摘要',
            tw: '標題/摘要',
            jp: '名称/要約',
            de: 'Titel/Abstract',
        },
    },
    {
        name: 'DESC',
        value: 'DESC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Description',
            cn: '说明书',
            tw: '說明書',
            jp: '明細書',
            de: 'Beschreibung',
        },
    },
    {
        name: 'TTL',
        value: 'TTL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Title',
            cn: '标题',
            tw: '標題',
            jp: '名称',
            de: 'Titel',
        },
    },
    {
        name: 'PATSNAP_TTL',
        value: 'PATSNAP_TTL:()',
        labelPlaceholder: '',
        desc: {
            en: 'PatSnap Patent Title',
            cn: 'PatSnap专利标题',
            tw: 'PatSnap專利標題',
            jp: 'PatSnap特許タイトル',
            de: 'PatSnap Patent Title',
        },
    },
    {
        name: 'PBD',
        value: 'PBD:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Publication Date',
            cn: '公开日',
            tw: '公開日',
            jp: '公開(公告)日',
            de: 'Veröffentlichungsdatum',
        },
    },
    {
        name: 'PBD_Y',
        value: 'PBD_Y:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Year of Publication Date',
            cn: '公开年',
            tw: '公開年',
            jp: '公開年',
            de: 'Erscheinungsjahr',
        },
    },
    {
        name: 'PBD_YM',
        value: 'PBD_YM:[ TO 202012]',
        labelPlaceholder: '1893 TO 202012',
        desc: {
            en: 'Year and Month of Publication Date',
            cn: '公开年月',
            tw: '公開年月',
            jp: '公開年月',
            de: 'Jahr und Monat des Veröffentlichungsdatums',
        },
    },
    {
        name: 'EFAM_EPBD',
        value: 'EFAM_EPBD:[ TO 20231231]',
        labelPlaceholder: '',
        desc: {
            en: 'Earliest Patsnap Family Publication Date',
            cn: 'Patsnap同族最早公开日',
            tw: 'Patsnap同族最早公開日',
            jp: 'Patsnapファミリー最初公開日',
            de: 'Das früheste Veröffentlichungsdatum von Patsnap',
        },
    },
    {
        name: 'EFAM_EPBY',
        value: 'EFAM_EPBY:[ TO 2023]',
        labelPlaceholder: '',
        desc: {
            en: 'Earliest Patsnap Family Publication Year',
            cn: 'Patsnap同族最早公开年',
            tw: 'Patsnap同族最早公開年',
            jp: 'Patsnapファミリー最初公開年',
            de: 'Das erste Jahr der Veröffentlichung von Patsnap',
        },
    },
    {
        name: 'EFAM_EPBYM',
        value: 'EFAM_EPBYM:[ TO 202312]',
        labelPlaceholder: '',
        desc: {
            en: 'Earliest Patsnap Family Publication Year and Month',
            cn: 'Patsnap同族最早公开年月',
            tw: 'Patsnap同族最早公開年月',
            jp: 'Patsnapファミリー最初公開年月',
            de: 'Das früheste Datum, an dem die Familie Patsnap freigelassen wurde',
        },
    },
    {
        name: 'EFAM_EPRD',
        value: 'EFAM_EPRD:[ TO 20231231]',
        labelPlaceholder: '',
        desc: {
            en: 'Earliest Patsnap Family Priority Date',
            cn: 'Patsnap同族最早优先权日',
            tw: 'Patsnap同族最早優先權日',
            jp: 'Patsnapファミリー最初優先権日',
            de: 'Das früheste Prioritätsdatum von Patsnap',
        },
    },
    {
        name: 'EFAM_EPB_COUNTRY',
        value: 'EFAM_EPB_COUNTRY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Earliest Patsnap Family Publication Country/Region',
            cn: 'Patsnap同族最早公开国家/地区',
            tw: 'Patsnap同族最早公開國家/地區',
            jp: 'Patsnapファミリー最初公開国/地域',
            de: 'Das erste Land/die erste Region der Patsnap-Familie, das bekannt gegeben wird',
        },
    },
    {
        name: 'ABST',
        value: 'ABST:()',
        labelPlaceholder: '',
        desc: {
            en: 'Abstract',
            cn: '摘要',
            tw: '摘要',
            jp: '要約',
            de: 'Abstract',
        },
    },
    {
        name: 'MIPC',
        value: 'MIPC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Main IPC',
            cn: 'IPC主分类号',
            tw: 'IPC主分類號',
            jp: '主IPC',
            de: 'Haupt IPC',
        },
    },
    {
        name: 'IPC_GROUP',
        value: 'IPC_GROUP:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC分类号大组',
            de: 'IPC Group',
            en: 'IPC Group',
            jp: 'IPCメイングループ記号',
            tw: 'IPC分類號大組',
        },
    },
    {
        name: 'IPC_SUB_GROUP',
        value: 'IPC_SUB_GROUP:()',
        labelPlaceholder: '',
        desc: {
            cn: 'IPC分类号小组',
            de: 'IPC Sub Group',
            en: 'IPC Sub Group',
            jp: 'IPCサブグループ',
            tw: 'IPC分類號小組',
        },
    },
    {
        name: 'CLMS',
        value: 'CLMS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Claims',
            cn: '权利要求',
            tw: '權利要求',
            jp: '請求項',
            de: 'Ansprüche',
        },
    },
    {
        name: 'IN',
        value: 'IN:()',
        labelPlaceholder: '',
        desc: {
            en: 'Inventor Name',
            cn: '发明人',
            tw: '發明人',
            jp: '発明者',
            de: 'Erfinder',
        },
    },
    {
        name: 'INC',
        value: 'INC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current inventor',
            cn: '当前发明人',
            tw: '當前發明人',
            jp: '現在の発明者',
            de: 'Current inventor',
        },
    },
    {
        name: 'IN_EXACT',
        value: 'IN_EXACT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Exact Inventor Name',
            cn: '精准发明人',
            tw: '精准發明人',
            jp: '発明者(完全一致)',
            de: 'Genauer Erfindername',
        },
    },
    {
        name: 'APD',
        value: 'APD:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Application Date',
            cn: '申请日',
            tw: '申請日',
            jp: '出願日',
            de: 'Bewerbungsdatum',
        },
    },
    {
        name: 'APD_Y',
        value: 'APD_Y:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Year of Application Date',
            cn: '申请年',
            tw: '申請年',
            jp: '出願年',
            de: 'Jahr des Antragsdatums',
        },
    },
    {
        name: 'APD_YM',
        value: 'APD_YM:[ TO 202012]',
        labelPlaceholder: '1893 TO 202012',
        desc: {
            en: 'Year and Month of Application Date',
            cn: '申请年月',
            tw: '申請年月',
            jp: '出願年月',
            de: 'Jahr und Monat des Antragsdatums',
        },
    },
    {
        name: 'PE',
        value: 'PE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Primary Examiner',
            cn: '审查员',
            tw: '審查員',
            jp: '審査官',
            de: 'Überprüfer',
        },
    },
    {
        name: 'AT_C',
        value: 'AT_C:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Agent',
            cn: '当前代理人',
            tw: '當前代理人',
            jp: '現代理人',
            de: 'Current Agent',
        },
    },
    {
        name: 'ATC',
        value: 'ATC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Agency',
            cn: '代理机构',
            tw: '代理機構',
            jp: '特許事務所',
            de: 'Agentur',
        },
    },
    {
        name: 'ATCS',
        value: 'ATCS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Std. Agency',
            cn: '[标]代理机构',
            tw: '[標]代理機構',
            jp: '[標準]特許事務所',
            de: 'Std. Agency',
        },
    },
    {
        name: 'ATCC',
        value: 'ATCC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Agency',
            cn: '当前代理机构',
            tw: '當前代理機构',
            jp: '現在の代理事務所',
            de: 'Current Agency',
        },
    },
    {
        name: 'ATC_VALUE',
        value: 'ATC_VALUE:()',
        labelPlaceholder: '',
        desc: {
            cn: '委托代理机构专利',
            tw: '委托代理機構專利',
            en: 'Agency involvement',
            jp: '事務所代理特許',
        },
    },
    {
        name: 'CPC',
        value: 'CPC:()',
        labelPlaceholder: '',
        desc: {
            en: 'CPC',
            cn: 'CPC分类号',
            tw: 'CPC分類號',
            jp: 'CPC分類',
            de: 'Kooperative Patent Klassifikation',
        },
    },
    {
        name: 'LOC',
        value: 'LOC:()',
        labelPlaceholder: '',
        desc: {
            en: 'LOC',
            cn: 'LOC分类号',
            tw: 'LOC分類號',
            jp: 'LOC分類',
            de: 'Locarno Design Klassifizierung',
        },
    },
    {
        name: 'GBC',
        value: 'GBC:()',
        labelPlaceholder: '',
        desc: {
            en: 'GBC',
            cn: '国民经济行业分类号',
            tw: '國民經濟行業分類號',
            jp: '国民経済産業分類',
            de: 'GBC',
        },
    },
    {
        name: 'AT',
        value: 'AT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Attorney Name',
            cn: '代理人',
            tw: '代理人',
            jp: '代理人',
            de: 'Agent',
        },
    },
    {
        name: 'ICLMS',
        value: 'ICLMS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Independent Claims',
            cn: '独立权利要求',
            tw: '獨立權利要求',
            jp: '独立請求項',
            de: 'Unabhängige Ansprüche',
        },
    },
    {
        name: 'PRIORITY_DATE',
        value: 'PRIORITY_DATE:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Priority Date',
            cn: '优先权日',
            tw: '優先權日',
            jp: '優先権主張日',
            de: 'Prioritätsdatum',
        },
    },
    {
        name: 'UPC',
        value: 'UPC:()',
        labelPlaceholder: '',
        desc: {
            en: 'UPC',
            cn: 'UPC分类号',
            tw: 'UPC分類號',
            jp: 'UPC分類',
            de: 'US-Patent Klassifikation',
        },
    },
    {
        name: 'PATENT_TYPE',
        value: 'PATENT_TYPE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patent Type',
            cn: '专利类型',
            tw: '專利類型',
            jp: '特許タイプ',
            de: 'Patenttyp',
        },
    },
    {
        name: 'FI',
        value: 'FI:()',
        labelPlaceholder: '',
        desc: {
            en: 'FI',
            cn: 'FI分类号',
            tw: 'FI分類號',
            jp: 'FI分類番号',
            de: 'FI',
        },
    },
    {
        name: 'FTERM',
        value: 'FTERM:()',
        labelPlaceholder: '',
        desc: {
            en: 'F-TERM',
            cn: 'F-TERM分类号',
            tw: 'F-TERM分類號',
            jp: 'F-TERM分類番号',
            de: 'F-TERM',
        },
    },
    {
        name: 'IPC_LOW',
        value: 'IPC_LOW:()',
        labelPlaceholder: '',
        desc: {
            en: 'IPC (Hierarchy)',
            cn: 'IPC分类号下位组',
            tw: 'IPC分類號下位組',
            jp: 'IPC分類の下位グループ',
            de: 'IPC (Hierarchie)',
        },
    },
    {
        name: 'MIPC_LOW',
        value: 'MIPC_LOW:()',
        labelPlaceholder: '',
        desc: {
            en: 'Main IPC (Hierarchy)',
            cn: 'IPC主分类号下位组',
            tw: 'IPC主分類號下位組',
            jp: '主IPC分類の下位グループ',
            de: 'Haupt-IPC (Hierarchie)',
        },
    },
    {
        name: 'CPC_LOW',
        value: 'CPC_LOW:()',
        labelPlaceholder: '',
        desc: {
            en: 'CPC (Hierarchy)',
            cn: 'CPC分类号下位组',
            tw: 'CPC分類號下位組',
            jp: 'CPC分類の下位グループ',
            de: 'CPC (Hierarchie)',
        },
    },
    {
        name: 'UPC_LOW',
        value: 'UPC_LOW:()',
        labelPlaceholder: '',
        desc: {
            en: 'UPC (Hierarchy)',
            cn: 'UPC分类号下位组',
            tw: 'UPC分類號下位組',
            jp: 'UPC分類の下位グループ',
            de: 'UPC (Hierarchie)',
        },
    },
    {
        name: 'FI_LOW',
        value: 'FI_LOW:()',
        labelPlaceholder: '',
        desc: {
            en: 'FI (Hierarchy)',
            cn: 'FI分类号下位组',
            tw: 'FI分類號下位組',
            jp: 'FI分類の下位グループ',
            de: 'FI (Hierarchie)',
        },
    },
    {
        name: 'FTERM_LOW',
        value: 'FTERM_LOW:()',
        labelPlaceholder: '',
        desc: {
            en: 'F-TERM (Hierarchy)',
            cn: 'F-TERM分类号下位组',
            tw: 'F-TERM分類號下位組',
            jp: 'F-TERM分類の下位グループ',
            de: 'F-TERM (Hierarchie)',
        },
    },
    {
        name: 'ADC',
        value: 'ADC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Application domain',
            cn: '应用领域分类',
            tw: '應用領域分類',
            jp: '応用分野分類',
            de: 'Application domain',
        },
    },
    {
        name: 'TTC',
        value: 'TTC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Technology topic',
            cn: '技术主题分类',
            tw: '技術主題分類',
            jp: '技術トピック分類',
            de: 'Technology topic',
        },
    },
    {
        name: 'SEIC',
        value: 'SEIC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Main SEIC',
            cn: '战略新兴产业分类(主分类)',
            tw: '戰略新興產業分類(主分類)',
            jp: '主SEI',
            de: 'Main SEIC',
        },
    },
    {
        name: 'SEIC_ALL',
        value: 'SEIC_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'SEIC',
            cn: '战略新兴产业分类',
            tw: '戰略新興產業分類',
            jp: 'SEIC',
            de: 'SEIC',
        },
    },
    {
        name: 'AE',
        value: 'AE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Assistant Examiner',
            cn: '助理审查员',
            tw: '助理審查員',
            jp: '審査官補',
            de: 'Assistenzprüfer',
        },
    },
    {
        name: 'APNO',
        value: 'APNO:()',
        labelPlaceholder: '',
        desc: {
            en: 'Application Number',
            cn: '申请号',
            tw: '申請號',
            jp: '出願番号',
            de: 'Anmeldenummer',
        },
    },
    {
        name: 'AUTHORITY',
        value: 'AUTHORITY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Authority',
            cn: '受理局',
            tw: '受理局',
            jp: '発行国・機関',
            de: 'Behörde',
        },
    },
    {
        name: 'ANC_COUNTRY',
        value: 'ANC_COUNTRY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Assignee Region',
            cn: '当前申请(专利权)人区域',
            tw: '當前申請(專利權)人區域',
            jp: '現出願人(権利者)の国別',
            de: 'Current Assignee Region',
        },
    },
    {
        name: 'ANC_PROVINCE',
        value: 'ANC_PROVINCE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Assignee State/Province',
            cn: '当前申请(专利权)人州/省',
            tw: '當前申請(專利權)人州/省',
            jp: '現出願人(権利者)の州/省',
            de: 'Current-Assignee-Provinz',
        },
    },
    {
        name: 'AN_CITY',
        value: 'AN_CITY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Assignee City',
            cn: '原始申请(专利权)人地市',
            tw: '原始申請（專利權）人地市',
            jp: '出願人(権利者)の地級所在地',
            de: 'Original Assignee City',
        },
    },
    {
        name: 'AN_DISTRICT',
        value: 'AN_DISTRICT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Assignee County/District',
            cn: '原始申请(专利权)人区县',
            tw: '原始申請（專利權）人區縣',
            jp: '出願人(権利者)の県級所在地',
            de: 'Original Assignee County/District',
        },
    },
    {
        name: 'ANC_CITY',
        value: 'ANC_CITY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Assignee City',
            cn: '当前申请(专利权)人地市',
            tw: '當前申請（專利權）人地市',
            jp: '現出願人(権利者)の地級所在地',
            de: 'Current Assignee City',
        },
    },
    {
        name: 'ANC_DISTRICT',
        value: 'ANC_DISTRICT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Assignee County/District',
            cn: '当前申请(专利权)人区县',
            tw: '當前申請（專利權）人區縣',
            jp: '現出願人(権利者)の県級所在地',
            de: 'Current Assignee County/District',
        },
    },
    {
        name: 'F_ANC',
        value: 'F_ANC:()',
        labelPlaceholder: '',
        desc: {
            en: 'First Current Assignee',
            cn: '第一当前申请(专利权)人',
            tw: '第壹當前申請(專利權)人',
            jp: '現筆頭出願人(権利者)',
            de: 'Erster gegenwärtiger Beauftragter',
        },
    },
    {
        name: 'ANC_ADD',
        value: 'ANC_ADD:()',
        labelPlaceholder: '',
        desc: {
            en: 'Current Assignee Address',
            cn: '当前申请(专利权)人地址',
            tw: '當前申請(專利權)人地址',
            jp: '現出願人(権利者)の住所',
            de: 'Aktuelle Empfängeradresse',
        },
    },
    {
        name: 'IN_ADDRESS',
        value: 'IN_ADDRESS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Inventor Address',
            cn: '发明人地址',
            tw: '發明人地址',
            jp: '発明者の住所',
            de: 'Erfinder Adresse',
        },
    },
    {
        name: 'KD',
        value: 'KD:()',
        labelPlaceholder: '',
        desc: {
            en: 'Kind Code',
            cn: '文献代码',
            tw: '文獻代碼',
            jp: '文献コード',
            de: 'Dokument Code',
        },
    },
    {
        name: 'F_IN',
        value: 'F_IN:()',
        labelPlaceholder: '',
        desc: {
            en: 'First Inventor',
            cn: '第一发明人',
            tw: '第壹發明人',
            jp: '筆頭発明者',
            de: 'Erster Erfinder',
        },
    },
    {
        name: 'PRNO',
        value: 'PRNO:()',
        labelPlaceholder: '',
        desc: {
            en: 'Priority Number',
            cn: '优先权号',
            tw: '優先權號',
            jp: '優先権主張番号',
            de: 'Prioritätsnummer',
        },
    },
    {
        name: 'TTL_ENTRANS',
        value: 'TTL_ENTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'English Translated Title',
            cn: '英文机翻标题',
            tw: '英文機翻標題',
            jp: '名称の翻訳(英)',
            de: 'Englischer übersetzter Titel',
        },
    },
    {
        name: 'ABST_ENTRANS',
        value: 'ABST_ENTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'English Translated Abstract',
            cn: '英文机翻摘要',
            tw: '英文機翻摘要',
            jp: '要約の翻訳(英)',
            de: 'Englisch übersetzte Zusammenfassung',
        },
    },
    {
        name: 'CLMS_ENTRANS',
        value: 'CLMS_ENTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'English Translated Claims',
            cn: '英文机翻权利要求',
            tw: '英文機翻權利要求',
            jp: '請求項の翻訳(英)',
            de: 'Englisch übersetzte Ansprüche',
        },
    },
    {
        name: 'TTL_CNTRANS',
        value: 'TTL_CNTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Chinese Translated Title',
            cn: '中文机翻标题',
            tw: '中文機翻標題',
            jp: '名称の翻訳(中)',
            de: 'Chinesischer übersetzter Titel',
        },
    },
    {
        name: 'ABST_CNTRANS',
        value: 'ABST_CNTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Chinese Translated Abstract',
            cn: '中文机翻摘要',
            tw: '中文機翻摘要',
            jp: '要約の翻訳(中)',
            de: 'Chinesisch übersetzte Zusammenfassung',
        },
    },
    {
        name: 'CLMS_CNTRANS',
        value: 'CLMS_CNTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Chinese Translated Claims',
            cn: '中文机翻权利要求',
            tw: '中文機翻權利要求',
            jp: '請求項の翻訳(中)',
            de: 'Chinesisch übersetzte Ansprüche',
        },
    }, {
        name: 'LEGAL_STATUS',
        value: 'LEGAL_STATUS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Legal Status',
            cn: '法律状态',
            tw: '法律狀態',
            jp: 'リーガルステータス',
            de: 'Rechtlicher Status',
        },
    },
    {
        name: 'ISD',
        value: 'ISD:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Issue Date',
            cn: '授权日',
            tw: '授權日',
            jp: '登録日',
            de: 'Autorisierungstag',
        },
    },
    {
        name: 'EXPD',
        value: 'EXPD:[ TO 20211231]',
        labelPlaceholder: '20210101 TO 20211231',
        desc: {
            en: 'Expiry date',
            cn: '失效日',
            tw: '失效日',
            jp: '失効日',
            de: 'Expiry date',
        },
    },
    {
        name: 'EXDT',
        value: 'EXDT:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Estimated Expiry Date',
            cn: '预估到期日',
            tw: '預估到期日',
            jp: '推定期間満了日',
            de: 'Fälligkeitsdatum',
        },
    },
    {
        name: 'PCTENTRY_DATE',
        value: 'PCTENTRY_DATE:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'PCT Entry Date',
            cn: 'PCT进入国家阶段日',
            tw: 'PCT進入國家階段日',
            jp: '国内段階への移行日',
            de: 'PCT Nationale Phase eingebendes Datum',
        },
    },
    {
        name: 'VERDICT_DATE',
        value: 'VERDICT_DATE:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Verdict Date',
            cn: '裁判日期',
            tw: '裁判日期',
            jp: '判決日',
            de: 'Urteil Zeit',
        },
    },
    {
        name: 'VERDICT',
        value: 'VERDICT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Verdict',
            cn: '判决结果',
            tw: '判決結果',
            jp: '判決結果',
            de: 'Verdict',
        },
    },
    {
        name: 'PARTY',
        value: 'PARTY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Party',
            cn: '当事人',
            tw: '當事人',
            jp: '当事者',
            de: 'Party',
        },
    },
    {
        name: 'PARTY_AGENT',
        value: 'PARTY_AGENT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Party Agent',
            cn: '当事人委托代理人',
            tw: '當事人委託代理人',
            jp: '当事者の代理人',
            de: 'Party Agent',
        },
    },
    {
        name: 'PARTY_LAWFIRM',
        value: 'PARTY_LAWFIRM:()',
        labelPlaceholder: '',
        desc: {
            en: 'Party Attorney',
            cn: '当事人委托律所',
            tw: '當事人委託律所',
            jp: '当事者の委託事務所',
            de: 'Party Attorney',
        },
    },
    {
        name: 'HEARING_DATE',
        value: 'HEARING_DATE:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Hearing Date',
            cn: '听证日期',
            tw: '聽證日期',
            jp: '公聴日',
            de: 'Anhörung Datum',
        },
    },
    {
        name: 'LIT_CLOSEDT',
        value: 'LIT_CLOSEDT:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Date Closed',
            cn: '结案日期',
            tw: '結案日期',
            jp: '結審日',
            de: 'Ende des Falles',
        },
    },
    {
        name: 'LIC_EFDT',
        value: 'LIC_EFDT:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Effective Date',
            cn: '许可生效日',
            tw: '許可生效日',
            jp: 'ライセンス発効日',
            de: 'Genehmigung gültiges Datum',
        },
    },
    {
        name: 'RIDDT',
        value: 'RIDDT:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Decision/Declaration Date',
            cn: '决定/发文日',
            tw: '决定/發文日',
            jp: '決定日/発行日',
            de: 'Decision/Declaration Date',
        },
    },
    {
        name: 'RI_FDT',
        value: 'RI_FDT:[20200101 TO 20201231]',
        labelPlaceholder: '20200101 TO 20201231',
        desc: {
            en: 'Reexamination / Invalidation Filing Date',
            cn: '复审/无效请求日',
            tw: '複審／無效請求日',
            jp: '再審査／無効審判請求日',
            de: 'Reexamination / Invalidation Filing Date',
        },
    },
    {
        name: 'PLE_EFDT',
        value: 'PLE_EFDT:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Pledge Effect Date',
            cn: '质押生效日',
            tw: '質押生效日',
            jp: '質権発効日',
            de: 'Versprechen Datum',
        },
    },
    {
        name: 'CLAIM_COUNT',
        value: 'CLAIM_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Claim Count',
            cn: '权利要求数',
            tw: '權利要求數',
            jp: '請求項数',
            de: 'Anzahl der Ansprüche',
        },
    },
    {
        name: 'ICLMS_COUNT',
        value: 'ICLMS_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Number of Independent Claims',
            cn: '独立权利要求数',
            tw: '獨立請求項數',
            jp: '独立クレーム数',
            de: 'Number of Independent Claims',
        },
    },
    {
        name: 'FCLMS_WORDCOUNT',
        value: 'FCLMS_WORDCOUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Word count of first claim',
            cn: '第一权利要求字数',
            tw: '第一權利要求字數',
            jp: '第1請求項の文字数',
            de: 'Word count of first claim',
        },
    },
    {
        name: 'DIV',
        value: 'DIV:1',
        labelPlaceholder: '',
        desc: {
            en: 'Divisional Application',
            cn: '专利分案',
            tw: '專利分案',
            jp: '特許分割出願',
            de: 'Divisional Application',
        },
    },
    {
        name: 'TD',
        value: 'TD:1',
        labelPlaceholder: '',
        desc: {
            en: 'Terminal Disclaimer',
            cn: '最终免责声明',
            tw: '最終免責聲明',
            jp: '最終免責宣言',
            de: 'Terminal Disclaimer',
        },
    },
    {
        name: 'PC_ENTRY',
        value: 'PC_ENTRY:1',
        labelPlaceholder: '',
        desc: {
            en: 'Paris Convention Route',
            cn: '巴黎公约路径进入专利',
            tw: '巴黎公約路徑進入專利',
            jp: 'パリ条約ルートによる移行特許',
            de: 'Paris Convention Route',
        },
    },
    {
        name: 'CONTINUATION',
        value: 'CONTINUATION:1',
        labelPlaceholder: '',
        desc: {
            en: 'Continuation Application',
            cn: '专利接续案',
            tw: '專利接續案',
            jp: '特許継続出願',
            de: 'Continuation Application',
        },
    },
    {
        name: 'ENTRY_COUNTRY',
        value: 'ENTRY_COUNTRY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Entry Country/Region',
            cn: '进入国家/地区',
            tw: '進入國家/地區',
            jp: '国/地域へ移行する',
            de: 'Entry Country/Region',
        },
    },
    {
        name: 'ENTRY_COUNTRY_LS',
        value: 'ENTRY_COUNTRY_LS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Legal Status of Entry Country/Region',
            cn: '进入国家/地区法律状态',
            tw: '進入國家/地區法律狀態',
            jp: '移行する国/地域リーガルステータス',
            de: 'Legal Status of Entry Country/Region',
        },
    },
    {
        name: 'ENTRY_COUNTRY_SLS',
        value: 'ENTRY_COUNTRY_SLS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Simple Legal Status of Entry Country/Region',
            cn: '进入国家/地区简单法律状态',
            tw: '進入國家/地區簡單法律狀態',
            jp: '移行する国/地域簡単リーガルステータス',
            de: 'Simple Legal Status of Entry Country/Region',
        },
    },
    {
        name: 'PV',
        value: 'PV:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Patent Value',
            cn: '专利价值',
            tw: '專利價值',
            jp: '特許価値',
            de: 'Patent Wert',
        },
    },
    {
        name: 'GOV',
        value: 'GOV:()',
        labelPlaceholder: '',
        desc: {
            en: 'Government Interest',
            cn: '政府利益',
            tw: '政府利益',
            jp: '政府利益',
            de: 'Regierungsinteressen',
        },
    },
    {
        name: 'F_CITES',
        value: 'F_CITES:()',
        labelPlaceholder: '',
        desc: {
            en: 'Forward Citations',
            cn: '被引用专利',
            tw: '被引用專利',
            jp: '被引用特許',
            de: 'Zitierte Patente',
        },
    },
    {
        name: 'BF_CITES',
        value: 'BF_CITES:()',
        labelPlaceholder: '',
        desc: {
            en: 'Backward Or Forward Citations',
            cn: '引用或被引用专利',
            tw: '引用或被引用專利',
            jp: '特許の引用又被引用',
            de: 'Backward Or Forward Citations',
        },
    },
    {
        name: 'PCTENTRY_TYPE',
        value: 'PCTENTRY_TYPE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patent Records Via PCT',
            cn: 'PCT路径进入专利',
            tw: 'PCT路徑進入專利',
            jp: 'PCTルートで国内移行した特許',
            de: 'Patent Records Via PCT',
        },
    },
    {
        name: 'FAM',
        value: 'FAM:()',
        labelPlaceholder: '',
        desc: {
            en: 'Simple Family',
            cn: '简单同族',
            tw: '簡單同族',
            jp: 'シンプルファミリー',
            de: 'Simple Familie',
        },
    },
    {
        name: 'IFAM',
        value: 'IFAM:()',
        labelPlaceholder: '',
        desc: {
            en: 'INPADOC Family',
            cn: 'INPADOC同族',
            tw: 'INPADOC同族',
            jp: 'INPADOCファミリー',
            de: 'INPADOC Familie',
        },
    },
    {
        name: 'EFAM',
        value: 'EFAM:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patsnap Family',
            cn: 'Patsnap同族',
            tw: 'Patsnap同族',
            jp: 'Patsnapファミリー',
            de: 'Patsnap Familie',
        },
    },
    {
        name: 'CASENO',
        value: 'CASENO:()',
        labelPlaceholder: '',
        desc: {
            en: 'Case No.',
            cn: '案件号',
            tw: '案件號',
            jp: '訴訟番号',
            de: 'Fallnummer',
        },
    },
    {
        name: 'COURT',
        value: 'COURT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Court',
            cn: '审理法院',
            tw: '審理法院',
            jp: '裁判所',
            de: 'Adjudationsgericht',
        },
    },
    {
        name: 'COURT_GRADE',
        value: 'COURT_GRADE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Court Level',
            cn: '法院级别',
            tw: '法院級別',
            jp: '裁判所の等級',
            de: 'Court Level',
        },
    },
    {
        name: 'JUDGE',
        value: 'JUDGE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Judge',
            cn: '审判员',
            tw: '審判員',
            jp: '裁判官',
            de: 'Richter',
        },
    },
    {
        name: 'CHIEF_JUDGE',
        value: 'CHIEF_JUDGE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Chief Judge',
            cn: '审判长',
            tw: '審判長',
            jp: '裁判長',
            de: 'Richter',
        },
    },
    {
        name: 'PLAINTIFF',
        value: 'PLAINTIFF:()',
        labelPlaceholder: '',
        desc: {
            en: 'Plaintiff Name',
            cn: '原告',
            tw: '原告',
            jp: '原告',
            de: 'Kläger',
        },
    },
    {
        name: 'AMOUNT_PLAINTIFF',
        value: 'AMOUNT_PLAINTIFF:[ TO *]',
        labelPlaceholder: '',
        desc: {
            en: 'Damages Claimed',
            cn: '申请赔偿总额',
            tw: '申請賠償總額',
            jp: '請求損害賠償額',
            de: 'Damages Claimed',
        },
    },
    {
        name: 'DEFENDANT',
        value: 'DEFENDANT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Defendant Name',
            cn: '被告',
            tw: '被告',
            jp: '被告',
            de: 'Angeklagte',
        },
    },
    {
        name: 'DAMAGES_AMOUNT',
        value: 'DAMAGES_AMOUNT:[ TO *]',
        labelPlaceholder: '',
        desc: {
            en: 'Damages',
            cn: '判赔总额',
            tw: '判賠總額',
            jp: '判定金額',
            de: 'Damages',
        },
    },
    {
        name: 'FILING_DATE',
        value: 'FILING_DATE:[ TO 2020]',
        labelPlaceholder: '',
        desc: {
            en: 'Litigation Filing Date',
            cn: '立案日期',
            tw: '立案日期',
            jp: '訴訟事件登記日',
            de: 'Einreichung Jahr',
        },
    },
    {
        name: 'FILING_YEAR',
        value: 'FILING_YEAR:[ TO 2020]',
        labelPlaceholder: '',
        desc: {
            en: 'Litigation Filing Year',
            cn: '立案年份',
            tw: '立案年份',
            jp: '訴訟事件登記年',
            de: 'Litigation Filing Year',
        },
    },
    {
        name: 'CASE_TITLE',
        value: 'CASE_TITLE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Case Title',
            cn: '案件标题',
            tw: '案件標題',
            jp: '事件名',
            de: 'Titel des Falles',
        },
    },
    {
        name: 'CASE_FULL_TEXT',
        value: 'CASE_FULL_TEXT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Fulltext',
            cn: '案件全文',
            tw: '案件全文',
            jp: '事件全文',
            de: 'Ganzer Text des Falles',
        },
    },
    {
        name: 'CASE_DOC_TYPE',
        value: 'CASE_DOC_TYPE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Case Type',
            cn: '文书类型',
            tw: '文書類型',
            jp: '文書の種類',
            de: 'Case Type',
        },
    },
    {
        name: 'LICENSOR',
        value: 'LICENSOR:()',
        labelPlaceholder: '',
        desc: {
            en: 'Licensor',
            cn: '许可人',
            tw: '許可人',
            jp: 'ライセンサー',
            de: 'Lizenzgeber',
        },
    },
    {
        name: 'LICENSEE',
        value: 'LICENSEE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Licensee',
            cn: '被许可人',
            tw: '被許可人',
            jp: 'ライセンシー',
            de: 'Lizenznehmer',
        },
    },
    {
        name: 'LICNO',
        value: 'LICNO:()',
        labelPlaceholder: '',
        desc: {
            en: 'License Number',
            cn: '许可合同备案号',
            tw: '許可合同備案號',
            jp: 'ライセンス契約番号',
            de: 'Lizenzvertrag Nummer',
        },
    },
    {
        name: 'RI_APPLICANT',
        value: 'RI_APPLICANT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Reexam/Invalid Applicant',
            cn: '复审/无效请求人',
            tw: '複審/無效請求人',
            jp: '再審・無効請求人',
            de: 'Überprüfung / ungültiger Anforderer',
        },
    },
    {
        name: 'RI_PETITIONER_AGENT',
        value: 'RI_PETITIONER_AGENT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Reexamination / Invalidation Petitioner Representative',
            cn: '复审/无效请求方代理人',
            tw: '複審／無效請求方代理人',
            jp: '再審査／無効審判請求当事者の代理人',
            de: 'Reexamination / Invalidation Petitioner Representative',
        },
    },
    {
        name: 'RI_PETITIONER_AGENCY',
        value: 'RI_PETITIONER_AGENCY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Reexamination / Invalidation Petitioner Agency',
            cn: '复审/无效请求方代理机构',
            tw: '複審／無效請求方代理機構',
            jp: '再審査／無効審判請求当事者の代理事務所',
            de: 'Reexamination / Invalidation Petitioner Agency',
        },
    },
    {
        name: 'RI_RESPONDENT_AGENT',
        value: 'RI_RESPONDENT_AGENT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Reexamination / Invalidation Respondent Representative',
            cn: '复审/无效被请求方代理人',
            tw: '複審／無效被請求方代理人',
            jp: '再審査／無効審判被請求当事者の代理人',
            de: 'Reexamination / Invalidation Respondent Representative',
        },
    },
    {
        name: 'RI_RESPONDENT_AGENCY',
        value: 'RI_RESPONDENT_AGENCY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Reexamination / Invalidation Respondent Agency',
            cn: '复审/无效被请求方代理机构',
            tw: '複審／無效被請求方代理機構',
            jp: '再審査／無効審判被請求当事者の代理事務所',
            de: 'Reexamination / Invalidation Respondent Agency',
        },
    },
    {
        name: 'RIDN',
        value: 'RIDN:()',
        labelPlaceholder: '',
        desc: {
            en: 'Decision Number',
            cn: '决定号',
            tw: '決定號',
            jp: '審判番号',
            de: 'Entscheidungsnummer',
        },
    },
    {
        name: 'RIIN',
        value: 'RIIN:()',
        labelPlaceholder: '',
        desc: {
            en: 'Internal number',
            cn: '委内编号',
            tw: '委內編號',
            jp: '内部番号',
            de: 'Internal number',
        },
    },
    {
        name: 'RIDTP',
        value: 'RIDTP:()',
        labelPlaceholder: '',
        desc: {
            en: 'Decision Type',
            cn: '决定类型',
            tw: '決定類型',
            jp: '決定類型',
            de: 'Entscheidung Typ',
        },
    },
    {
        name: 'RIDP',
        value: 'RIDP:()',
        labelPlaceholder: '',
        desc: {
            en: 'Decision Points',
            cn: '决定要点',
            tw: '決定要點',
            jp: '決定要点',
            de: 'Beschlossene Punkte',
        },
    },
    {
        name: 'RID',
        value: 'RID:()',
        labelPlaceholder: '',
        desc: {
            en: 'Decision',
            cn: '决定',
            tw: '決定',
            jp: '決定',
            de: 'Entscheidung',
        },
    },
    {
        name: 'PLEDGOR',
        value: 'PLEDGOR:()',
        labelPlaceholder: '',
        desc: {
            en: 'Pledgor',
            cn: '质押人',
            tw: '質押人',
            jp: '質入者',
            de: 'Pledger',
        },
    },
    {
        name: 'PLEDGEE',
        value: 'PLEDGEE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Pledgee',
            cn: '质权人',
            tw: '質權人',
            jp: '質権者',
            de: 'Pledgee',
        },
    },
    {
        name: 'PLEDGENO',
        value: 'PLEDGENO:()',
        labelPlaceholder: '',
        desc: {
            en: 'Pledge Number',
            cn: '质押登记号',
            tw: '質押登記號',
            jp: '質権登録番号',
            de: 'Versprechen Registrierungsnummer',
        },
    },
    {
        name: 'PLE_STAGE',
        value: 'PLE_STAGE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Pledge Stage',
            cn: '质押备案阶段',
            tw: '質押備案階段',
            jp: '質権届出段階',
            de: 'Versprechen Aufnahme Stufe',
        },
    },
    {
        name: 'B_CITES_COUNT',
        value: 'B_CITES_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Count Of Backward Citations',
            cn: '引用专利数量',
            tw: '引用專利數量',
            jp: '引用件数',
            de: 'Zitieren Zahl',
        },
    },
    {
        name: 'F_CITES_COUNT',
        value: 'F_CITES_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Count Of Forward Citations',
            cn: '被引用专利数量',
            tw: '被引用專利數量',
            jp: '被引用件数',
            de: 'Zitieren Zahl',
        },
    },
    {
        name: 'F_CITES_ANC',
        value: 'F_CITES_ANC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Assignee Forward Citations (Current)',
            cn: '引用当前申请人',
            tw: '引用當前申請人',
            jp: '現出願人を引用した',
            de: 'Cited assignee (current)',
        },
    },
    {
        name: 'B_CITES_ANC',
        value: 'B_CITES_ANC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Assignee Backward Citations (Current)',
            cn: '当前申请人引用',
            tw: '當前申請人引用',
            jp: '現出願人により引用された',
            de: 'Assignee Backward Citations (Current)',
        },
    },
    {
        name: 'EFAM_COUNT',
        value: 'EFAM_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Patsnap Family Application Count',
            cn: 'Patsnap同族专利申请数量',
            tw: 'Patsnap同族專利申請數量',
            jp: 'Patsnapファミリー出願件数',
            de: 'Patsnap Family Application Count',
        },
    },
    {
        name: 'FAM_COUNT',
        value: 'FAM_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Simple Family Application Count',
            cn: '简单同族专利申请数量',
            tw: '簡單同族專利申請數量',
            jp: 'シンプルファミリー出願件数',
            de: 'Simple Family Application Count',
        },
    },
    {
        name: 'FAM_COUNTRY',
        value: 'FAM_COUNTRY:()',
        labelPlaceholder: 'FAM_COUNTRY:()',
        desc: {
            en: 'Simple Family Jurisdiction',
            cn: '简单同族国家/地区',
            tw: '簡單同族國家/地區',
            jp: 'シンプルファミリー国・地域',
            de: 'Einfache Präsenz der Familiengerichtsbarkeit',
        },
    }, {
        name: 'EFAM_COUNTRY',
        value: 'EFAM_COUNTRY:()',
        labelPlaceholder: 'EFAM_COUNTRY:()',
        desc: {
            en: 'Patsnap Family Jurisdiction',
            cn: 'Patsnap同族国家/地区',
            tw: 'Patsnap同族國家/地區',
            jp: 'ファミリー国・地域',
            de: 'Präsenz der Familiengerichtsbarkeit',
        },
    },
    {
        name: 'IFAM_COUNT',
        value: 'IFAM_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'INPADOC Family Application Count',
            cn: 'INPADOC同族专利申请数量',
            tw: 'INPADOC同族專利申請數量',
            jp: 'INPADOCファミリー出願件数',
            de: 'INPADOC Family Application Count',
        },
    },
    {
        name: 'FAM_COUNTRY_COUNT',
        value: 'FAM_COUNTRY_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Simple Family Jurisdiction Count',
            cn: '简单同族国家/地区数量',
            tw: '簡單同族國家/地區數量',
            jp: 'シンプルファミリー国/地域数',
            de: 'Simple Family Jurisdiction Count',
        },
    },
    {
        name: 'IFAM_COUNTRY_COUNT',
        value: 'IFAM_COUNTRY_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'INPADOC Family Jurisdiction Count',
            cn: 'INPADOC同族国家/地区数量',
            tw: 'INPADOC同族國家/地區數量',
            jp: 'INPADOCファミリー国/地域数',
            de: 'INPADOC Family Jurisdiction Count',
        },
    },
    {
        name: 'EFAM_COUNTRY_COUNT',
        value: 'EFAM_COUNTRY_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Patsnap Family Jurisdiction Count',
            cn: 'Patsnap同族国家/地区数量',
            tw: 'Patsnap同族國家/地區數量',
            jp: 'Patsnapファミリー国/地域数',
            de: 'Patsnap Family Jurisdiction Count',
        },
    },
    {
        name: 'ANCS_TYPE',
        value: 'ANCS_TYPE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Std. Current Assignee Type',
            cn: '[标]当前申请(专利权)人类型',
            tw: '[標]當前申請(專利權)人類型',
            jp: '[標準]現出願人(権利者)のタイプ',
            de: 'Standardisierter aktueller Beauftragungstyp',
        },
    },
    {
        name: 'ANS_TYPE',
        value: 'ANS_TYPE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Std. Original Assignee Type',
            cn: '[标]原始申请(专利权)人类型',
            tw: '[標]原始申請(專利權)人類型',
            jp: '[標準]出願人(権利者)のタイプ',
            de: 'Std. Original Assignee Type',
        },
    },
    {
        name: 'CASE_REGION',
        value: 'CASE_REGION:()',
        labelPlaceholder: '',
        desc: {
            en: 'Case Region',
            cn: '审理地域',
            tw: '審理地域',
            jp: '事件場所',
            de: 'Fallbereich',
        },
    },
    {
        name: 'TRIAL_GRADE',
        value: 'TRIAL_GRADE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Trial Level',
            cn: '审理程序',
            tw: '審理程序',
            jp: '訴訟審級',
            de: 'Prozess Teststufe',
        },
    },
    {
        name: 'CASE_NATURE',
        value: 'CASE_NATURE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Case Property',
            cn: '案件性质',
            tw: '案件性質',
            jp: '訴訟類型',
            de: 'Art des Falles',
        },
    },
    {
        name: 'CASE_LEVEL',
        value: 'CASE_LEVEL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Case Level',
            cn: '案例级别',
            tw: '案例級別',
            jp: '案件等級',
            de: 'Case Level',
        },
    },
    {
        name: 'OUTCOME_STATUS',
        value: 'OUTCOME_STATUS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Outcome Status',
            cn: '案件状态',
            tw: '案件狀態',
            jp: '案件の状況',
            de: 'Patent Prozess Kläger',
        },
    },
    {
        name: 'EXCLUSIVITY',
        value: 'EXCLUSIVITY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Exclusivity',
            cn: '许可排他性',
            tw: '許可排他性',
            jp: 'ライセンスタイプ',
            de: 'Zulässige Exklusivität',
        },
    },
    //   {
    //     name: 'CLAIM_TYPE',
    //     value: 'CLAIM_TYPE:()',
    //     labelPlaceholder: '',
    //     desc: {
    //       en: 'Claim Type',
    //       cn: '权利要求类型',
    //       tw: '權利要求類型',
    //       jp: '請求項タイプ',
    //       de: 'Anspruchstyp'
    //     }
    //   },
    {
        name: 'SEP_SOURCE',
        value: 'SEP_SOURCE:()',
        labelPlaceholder: '',
        desc: {
            en: 'SEP Source',
            cn: 'SEP数据源',
            tw: 'SEP數據源',
            jp: 'SEPソース',
            de: 'SEP-Standard',
        },
    },
    {
        name: 'SEP_TITLE',
        value: 'SEP_TITLE:()',
        labelPlaceholder: '',
        desc: {
            en: 'SEP Title',
            cn: 'SEP标准标题',
            tw: 'SEP標準標題',
            jp: 'SEP標準名称',
            de: 'SEP-Standardtitel',
        },
    },
    {
        name: 'SEP_DECLARANT',
        value: 'SEP_DECLARANT:()',
        labelPlaceholder: '',
        desc: {
            en: 'SEP Declarant',
            cn: 'SEP标准持有者',
            tw: 'SEP標準持有者',
            jp: 'SEP標準保持者',
            de: 'SEP Standardhalter',
        },
    },
    {
        name: 'SIMPLE_LEGAL_STATUS',
        value: 'SIMPLE_LEGAL_STATUS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Simple Legal Status',
            cn: '简单法律状态',
            tw: '簡單法律狀態',
            jp: '簡単リーガルステータス',
            de: 'Einfach Rechtsstatus',
        },
    },
    {
        name: 'LITIGATION',
        value: 'LITIGATION:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patents with litigation information',
            cn: '专利诉讼',
            tw: '專利訴訟',
            jp: '特許訴訟',
            de: 'Patent Prozess',
        },
    },
    {
        name: 'LITIGATION_PRODUCT',
        value: 'LITIGATION_PRODUCT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Product(s)',
            cn: '涉及产品',
            tw: '涉及產品',
            jp: '関係製品',
            de: 'Product(s)',
        },
    },
    {
        name: 'LICENSE',
        value: 'LICENSE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patents with licensing information',
            cn: '所有发生许可的专利',
            tw: '所有發生許可的專利',
            jp: '特許ライセンス',
            de: 'Patent Lizenz',
        },
    },
    {
        name: 'PLEDGE',
        value: 'PLEDGE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patents with pledge information',
            cn: '专利质押',
            tw: '專利質押',
            jp: '質権のタグ',
            de: 'Patent Pledge',
        },
    },
    {
        name: 'REEXAMINVALID',
        value: 'REEXAMINVALID:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patents with re-examination/invalidation information',
            cn: '所有发生复审/无效的专利',
            tw: '所有發生復審/無效的專利',
            jp: '再審・無効審判のタグ',
            de: 'Ungültige Prüfung',
        },
    },
    {
        name: 'RIDSM',
        value: 'RIDSM:()',
        labelPlaceholder: '',
        desc: {
            en: 'Decision Summary',
            cn: '案由',
            tw: '案由',
            jp: '控訴の趣旨',
            de: 'Decision Summary',
        },
    },
    {
        name: 'RI_FULL_TEXT',
        value: 'RI_FULL_TEXT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Re-exam/Invalid full text',
            cn: '复审/无效全文',
            tw: '複審/無效全文',
            jp: '再審/無効審判全文',
            de: 'Re-exam/Invalid full text',
        },
    },
    {
        name: 'RILGS',
        value: 'RILGS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Legal Grounds',
            cn: '法律依据',
            tw: '法律依據',
            jp: '法的根拠',
            de: 'Legal Grounds',
        },
    }, {
        name: 'GNAME',
        value: 'GNAME:()',
        labelPlaceholder: '',
        desc: {
            en: 'Grouped Assignee',
            cn: '自定义申请人组',
            tw: '自定義申請人組',
            jp: 'カスタム権利者グループ',
            de: 'Grouped Assignee',
        },
    }, {
        name: 'TACD',
        value: 'TACD:()',
        labelPlaceholder: '',
        desc: {
            en: 'Title/Abstract/Claims/Description',
            cn: '标题/摘要/权利要求/说明书',
            tw: '標題/摘要/權利要求/說明書',
            jp: '名称/要約/請求項/明細書',
            de: 'Title/Abstract/Claims/Description',
        },
    }, {
        name: 'LEGAL_EVENT',
        value: 'LEGAL_EVENT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Legal Event',
            cn: '法律事件',
            tw: '法律事件',
            jp: 'リーガルイベント',
            de: 'Rechtliche Fragen',
        },
    },
    {
        name: 'B_CITES',
        value: 'B_CITES:()',
        labelPlaceholder: '',
        desc: {
            en: 'Backward Citations',
            cn: '引用专利',
            tw: '引用專利',
            jp: '引用特許',
            de: 'Backward Citations',
        },
    },
    {
        name: 'AN_COUNT',
        value: 'AN_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Count of Original Assignees (Applicant)',
            cn: '原始申请(专利权)人数量',
            tw: '原始申請(專利權)人數量',
            jp: '出願人(権利者)数',
            de: 'Anzahl der ursprünglichen Beauftragten (Antragsteller)',
        },
    },
    {
        name: 'ANC_COUNT',
        value: 'ANC_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Count of Current Assignees (Applicant)',
            cn: '当前申请(专利权)人数量',
            tw: '當前申請(專利權)人數量',
            jp: '現出願人(権利者)数',
            de: 'Anzahl der aktuellen Beauftragten (Bewerber)',
        },
    },
    {
        name: 'PAGE_COUNT',
        value: 'PAGE_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Page Count',
            cn: '文献页数',
            tw: '文獻頁數',
            jp: '出願書類ページ数',
            de: 'Seitenzahl',
        },
    },
    {
        name: 'EXAMINE_DATE',
        value: 'EXAMINE_DATE:[ TO 2020]',
        labelPlaceholder: '1893 TO 2020',
        desc: {
            en: 'Substantive Examination Date',
            cn: '实质审查生效日',
            tw: '實質審查生效日',
            jp: '実体審査の発効日',
            de: 'Substantives Prüfungstermin',
        },
    },
    {
        name: 'EXAMINE_PERIOD',
        value: 'EXAMINE_PERIOD:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            en: 'Examination Time',
            cn: '审查时长',
            tw: '審查時長',
            jp: '審査期間',
            de: 'Prüfungszeit',
        },
    },
    {
        name: 'PCT_APNO',
        value: 'PCT_APNO:()',
        labelPlaceholder: '',
        desc: {
            en: 'PCT Application Number',
            cn: 'PCT国际申请申请号',
            tw: 'PCT國際申請申請號',
            jp: '国際出願番号',
            de: 'PCT-Anmeldungsnummer',
        },
    },
    {
        name: 'PCT_PN',
        value: 'PCT_PN:()',
        labelPlaceholder: '',
        desc: {
            en: 'PCT Publication Number',
            cn: 'PCT国际申请公开号',
            tw: 'PCT國際申請公開號',
            jp: '国際公開(公告)番号',
            de: 'PCT Publication Number',
        },
    },
    {
        name: 'DESC_ENTRANS',
        value: 'DESC_ENTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'English Translated Description',
            cn: '英文机翻说明书',
            tw: '英文機翻說明書',
            jp: '明細書の翻訳(英)',
            de: 'Englische maschinell übersetzte Beschreibung',
        },
    },
    {
        name: 'DESC_CNTRANS',
        value: 'DESC_CNTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Chinese Translated Description',
            cn: '中文机翻说明书',
            tw: '中文機翻說明書',
            jp: '明細書の翻訳(中)',
            de: 'Chinesische maschinell übersetzte Beschreibung',
        },
    },
    {
        name: 'TTL_ALL',
        value: 'TTL_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Title And Translation',
            cn: '标题原文和翻译',
            tw: '標題原文和翻譯',
            jp: '名称の原文＆翻訳',
            de: 'Originaltitel und Übersetzung',
        },
    },
    {
        name: 'ABST_ALL',
        value: 'ABST_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Abstract And Translation',
            cn: '摘要原文和翻译',
            tw: '摘要原文和翻譯',
            jp: '要約の原文＆翻訳',
            de: 'Original Abstract und Übersetzung',
        },
    },
    {
        name: 'CLMS_ALL',
        value: 'CLMS_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Claims And Translation',
            cn: '权利要求原文和翻译',
            tw: '權利要求原文和翻譯',
            jp: '請求項の原文＆翻訳',
            de: 'Originalansprüche und Übersetzung',
        },
    },
    {
        name: 'DESC_ALL',
        value: 'DESC_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original Description And Translation',
            cn: '说明书原文和翻译',
            tw: '說明書原文和翻譯',
            jp: '明細書の原文＆翻訳',
            de: 'Originalbeschreibung und Übersetzung',
        },
    },
    {
        name: 'TA_ALL',
        value: 'TA_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original TA And Translation',
            cn: '标题/摘要原文和翻译',
            tw: '標題/摘要原文和翻譯',
            jp: '名称/要約の原文＆翻訳',
            de: 'Originaltitel / Abstract und Übersetzung',
        },
    },
    {
        name: 'TAC_ALL',
        value: 'TAC_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original TAC And Translation',
            cn: '标题/摘要/权利要求原文和翻译',
            tw: '標題/摘要/權利要求原文和翻譯',
            jp: '名称/要約/請求項の原文＆翻訳',
            de: 'Originaltitel / Abstract / Ansprüche und Übersetzung',
        },
    },
    {
        name: 'TACD_ALL',
        value: 'TACD_ALL:()',
        labelPlaceholder: '',
        desc: {
            en: 'Original TACD And Translation',
            cn: '标题/摘要/权利要求/说明书原文和翻译',
            tw: '標題/摘要/權利要求/說明書原文和翻譯',
            jp: '名称/要約/請求項/明細書の原文＆翻訳',
            de: 'Originaltitel / Abstract / Claims / Beschreibung und Übersetzung',
        },
    },
    {
        name: 'PROBLEM_SUM',
        value: 'PROBLEM_SUM:()',
        labelPlaceholder: '',
        desc: {
            en: 'Technical Problem',
            cn: '技术问题',
            tw: '科技問題',
            jp: '技術的課題',
            de: 'Technical Problem',
        },
    },
    {
        name: 'PROBLEM_PHR',
        value: 'PROBLEM_PHR:()',
        labelPlaceholder: '',
        desc: {
            en: 'Std. Technical Problem Phrase',
            cn: '[标]技术问题短语',
            tw: '[標]科技問題短語',
            jp: '[標]技術課題語句',
            de: 'Std. Technical Problem Phrase',
        },
    },
    {
        name: 'METHOD_SUM',
        value: 'METHOD_SUM:()',
        labelPlaceholder: '',
        desc: {
            en: 'Technical Method',
            cn: '技术手段',
            tw: '技術手段',
            jp: '技術的解決手段',
            de: 'Technical Method',
        },
    },
    {
        name: 'BENEFIT_PHR',
        value: 'BENEFIT_PHR:()',
        labelPlaceholder: '',
        desc: {
            en: 'Std. Technical Benefit Phrase',
            cn: '[标]技术功效短语',
            tw: '[標]技術功效短語',
            jp: '[標]技術効果語句',
            de: 'Std. Technical Benefit Phrase',
        },
    },
    {
        name: 'DESC_F',
        value: 'DESC_F:()',
        labelPlaceholder: '',
        desc: {
            en: 'Technical Field',
            cn: '技术领域',
            tw: '技術領域',
            jp: '技術分野',
            de: 'Technical Field',
        },
    }, {
        name: 'DESC_B',
        value: 'DESC_B:()',
        labelPlaceholder: '',
        desc: {
            en: 'Background Art',
            cn: '背景技术',
            tw: '背景技術',
            jp: '背景技術',
            de: 'Background Art',
        },
    }, {
        name: 'DESC_S',
        value: 'DESC_S:()',
        labelPlaceholder: '',
        desc: {
            en: 'Summary of Invention',
            cn: '发明内容',
            tw: '發明內容',
            jp: '発明の概要',
            de: 'Summary of Invention',
        },
    }, {
        name: 'DESC_D',
        value: 'DESC_D:()',
        labelPlaceholder: '',
        desc: {
            en: 'Brief Description of Drawings',
            cn: '附图说明',
            tw: '附圖說明',
            jp: '図面の簡単な説明',
            de: 'Brief Description of Drawings',
        },
    }, {
        name: 'DESC_E',
        value: 'DESC_E:()',
        labelPlaceholder: '',
        desc: {
            en: 'Description of Embodiments',
            cn: '具体实施方式',
            tw: '具體實施方式',
            jp: '発明を実施するための形態',
            de: 'Description of Embodiments',
        },
    }, {
        name: 'BENEFIT_SUM',
        value: 'BENEFIT_SUM:()',
        labelPlaceholder: '',
        desc: {
            en: 'Technical Benefit',
            cn: '技术功效',
            tw: '科技功效',
            jp: '技術的効果',
            de: 'Technical Benefit',
        },
    }, {
        name: 'PRIORITY_COUNTRY',
        value: 'PRIORITY_COUNTRY:()',
        labelPlaceholder: '',
        desc: {
            en: 'Priority Country/Region',
            cn: '优先权国家/地区',
            tw: '優先權國家/地區',
            jp: '優先権国・地域',
            de: 'Priority Country/Region',
        },
    }, {
        name: 'OUTCOME_JUDGEMENT',
        value: 'OUTCOME_JUDGEMENT:()',
        labelPlaceholder: '',
        desc: {
            en: 'Outcome of Judgement',
            cn: '胜诉方',
            tw: '勝訴方',
            jp: '勝利方',
            de: 'Outcome of Judgement',
        },
    },
    {
        name: 'AN_EN',
        value: 'AN_EN:()',
        labelPlaceholder: '',
        desc: {
            en: 'English Business Name',
            cn: '工商英文名',
            tw: '工商英文名',
            jp: '英文名称',
            de: 'English Business Name',
        },
    },
    {
        name: 'BI_USCC',
        value: 'BI_USCC:()',
        labelPlaceholder: '',
        desc: {
            en: 'Business Unified Social Credit Code for Industry and Commerce',
            cn: '工商统一社会信用代码',
            tw: '工商統一社會信用程式碼',
            jp: '登記統一社会信用コード',
            de: 'Business Unified Social Credit Code for Industry and Commerce',
        },
    },
    {
        name: 'BI_RN',
        value: 'BI_RN:()',
        labelPlaceholder: '',
        desc: {
            en: 'Business Registration Number',
            cn: '工商注册号',
            tw: '工商註冊號',
            jp: '登録番号',
            de: 'Business Registration Number',
        },
    },
    {
        name: 'BI_ADD',
        value: 'BI_ADD:()',
        labelPlaceholder: '',
        desc: {
            en: 'Business Registration Address',
            cn: '工商注册地址',
            tw: '工商注册地址',
            jp: '登記住所',
            de: 'Business Registration Address',
        },
    },
    {
        name: 'BI_ET',
        value: 'BI_ET:()',
        labelPlaceholder: '',
        desc: {
            en: 'Business Enterprise Type',
            cn: '工商企业类型',
            tw: '工商企業類型',
            jp: '登記会社種類',
            de: 'Business Enterprise Type',
        },
    },
    {
        name: 'BI_ED',
        value: 'BI_ED:()',
        labelPlaceholder: '',
        desc: {
            en: 'Business Establishment Date',
            cn: '工商成立日期',
            tw: '工商成立日期',
            jp: '登記設立日',
            de: 'Business Establishment Date',
        },
    },
    {
        name: 'BI_RS',
        value: 'BI_RS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Business Registration Status',
            cn: '工商登记状态',
            tw: '工商登記狀態',
            jp: '登記企業状態',
            de: 'Business Registration Status',
        },
    },
    {
        name: 'LC_CODE',
        value: 'LC_CODE:()',
        labelPlaceholder: '',
        desc: {
            en: 'Listed Company Code',
            cn: '工商上市公司代码',
            tw: '工商上市公司程式碼',
            jp: '市場コード',
            de: 'Listed Company Code',
        },
    },
    {
        name: 'MWS',
        value: 'MWS:()',
        labelPlaceholder: '',
        desc: {
            en: 'My Workspace',
            cn: '我的工作空间',
            tw: '我的工作空間',
            jp: '私のワークスペース',
            de: 'My Workspace',
        },
    },
    {
        name: 'CWS',
        value: 'CWS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Company Workspace',
            cn: '企业工作空间',
            tw: '企業工作空間',
            jp: '企業ワークスペース',
            de: 'Company Workspace',
        },
    },
    {
        name: 'AN_HIST',
        value: 'AN_HIST:()',
        labelPlaceholder: '',
        desc: {
            en: 'Historical Assignees',
            cn: '历史申请(专利权)人',
            tw: '歷史申請(專利權)人',
            jp: '歴史出願人(権利者)',
            de: 'Historical Assignees',
        },
    },
    {
        name: 'CLASS',
        value: 'CLASS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Patent Classification',
            cn: '联合分类号',
            tw: '聯合分類號',
            jp: '総合分類コード',
            de: 'Patent Classification',
        },
    },
    {
        name: 'EPDS',
        value: 'EPDS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'EP指定国家/地区',
            en: 'EP Designated State',
            tw: 'EP指定國家/地區',
            jp: 'EP指定国/地域',
            de: 'EP Designated State',
        },
    },
    {
        name: 'EP_ENTRY',
        value: 'EP_ENTRY:()',
        labelPlaceholder: '',
        desc: {
            cn: 'EPO路径进入专利',
            en: 'Patent Records Via EPO',
            tw: 'EPO路徑進入專利',
            jp: 'EPO国内移行特許',
            de: 'Patent Records Via EPO',
        },
    },
    {
        name: 'EPDS_LS',
        value: 'EPDS_LS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'EP指定国家/地区法律状态',
            en: 'EP Designated State Legal Status',
            tw: 'EP指定國家/地區法律狀態',
            jp: 'EP指定国/地域法的状況',
            de: 'EP Designated State Legal Status',
        },
    },
    {
        name: 'EPDS_SLS',
        value: 'EPDS_SLS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'EP指定国家/地区简单法律状态',
            en: 'EP Designated State Simple Legal Status',
            tw: 'EP指定國家/地區簡單法律狀態',
            jp: 'EP指定国/地域シンプル法的状況',
            de: 'EP Designated State Simple Legal Status',
        },
    },
    {
        name: 'EPDS_COUNT',
        value: 'EPDS_COUNT:[ TO *]',
        labelPlaceholder: '0 TO *',
        desc: {
            cn: 'EP指定国家/地区数量',
            en: 'EP Designated State Count',
            tw: 'EP指定國家/地區數量',
            jp: 'EP指定国/地域数',
            de: 'EP Designated State Count',
        },
    },
    {
        name: 'UP_STATUS',
        value: 'UP_STATUS:()',
        labelPlaceholder: '',
        desc: {
            cn: '欧洲统一法院状态',
            en: 'Status of Unified Patent Court',
            tw: '歐洲統一法院狀態',
            jp: 'UPCにおける法的状況',
            de: 'Status of Unified Patent Court',
        },
    },
    {
        name: 'ICLMS_ENTRANS',
        value: 'ICLMS_ENTRANS:()',
        labelPlaceholder: '',
        desc: {
            cn: '英文机翻独立权利要求',
            en: 'English Translated Independent Claims',
            tw: '英文機翻獨立權利要求',
            jp: '独立クレームの英語機械翻訳',
            de: 'English Translated Independent Claims',
        },
    },
    {
        name: 'ICLMS_CNTRANS',
        value: 'ICLMS_CNTRANS:()',
        labelPlaceholder: '',
        desc: {
            cn: '中文机翻独立权利要求',
            en: 'Chinese Translated Independent Claims',
            tw: '中文機翻獨立權利要求',
            jp: '独立クレームの中国語機械翻訳',
            de: 'Chinese Translated Independent Claims',
        },
    },
    {
        name: 'ICLMS_ALL',
        value: 'ICLMS_ALL:()',
        labelPlaceholder: '',
        desc: {
            cn: '独立权利要求原文和翻译',
            en: 'Original Independent Claims And Translation',
            tw: '獨立權利要求原文和翻譯',
            jp: '独立クレームの原文と訳文',
            de: 'Original Independent Claims And Translation',
        },
    },
    {
        name: 'FAM_ID',
        value: 'FAM_ID:()',
        labelPlaceholder: '',
        desc: {
            cn: '简单同族编号',
            en: 'Simple Family ID',
            tw: '簡單同族編號',
            jp: 'シンプルファミリー番号',
            de: 'Simple Family ID',
        },
    },
    {
        name: 'IFAM_ID',
        value: 'IFAM_ID:()',
        labelPlaceholder: '',
        desc: {
            cn: 'INPADOC同族编号',
            en: 'INPADOC Family ID',
            tw: 'INPADOC同族編號',
            jp: 'INPADOCファミリー番号',
            de: 'INPADOC Family ID',
        },
    },
    {
        name: 'EFAM_ID',
        value: 'EFAM_ID:()',
        labelPlaceholder: '',
        desc: {
            cn: 'Patsnap同族编号',
            en: 'Patsnap Family ID',
            tw: 'Patsnap同族編號',
            jp: 'Patsnapファミリー番号',
            de: 'Patsnap Family ID',
        },
    },
    {
        name: 'EFAM_STATUS',
        value: 'EFAM_STATUS:()',
        labelPlaceholder: '',
        desc: {
            cn: 'Patsnap同族状态',
            en: 'Patsnap Family Status',
            tw: 'Patsnap同族狀態',
            jp: 'Patsnapファミリーのステータス',
            de: 'Patsnap Family Legal Status',
        },
    },
];

export const SEARCH_FIELDS_US = [
    {
        name: 'TTL_JPTRANS',
        value: 'TTL_JPTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Japanese Translated Title',
            cn: '日文机翻标题',
            tw: '日文機翻標題',
            jp: '日本語機械翻訳のタイトル',
            de: 'Japanisch übersetzter Titel',
        },
    },
    {
        name: 'ABST_JPTRANS',
        value: 'ABST_JPTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Japanese Translated Abstract',
            cn: '日文机翻摘要',
            tw: '日文機翻摘要',
            jp: '日本語機械翻訳の要約',
            de: 'Japanisch übersetzte Zusammenfassung',
        },
    },
    {
        name: 'CLMS_JPTRANS',
        value: 'CLMS_JPTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Japanese Translated Claims',
            cn: '日文机翻权利要求',
            tw: '日文機翻權利要求',
            jp: '日本語機械翻訳の請求項',
            de: 'Japanisch übersetzte Ansprüche',
        },
    },
    {
        name: 'DESC_JPTRANS',
        value: 'DESC_JPTRANS:()',
        labelPlaceholder: '',
        desc: {
            en: 'Japanese Translated Description',
            cn: '日文机翻说明书',
            tw: '日文機翻說明書',
            jp: '日本語機械翻訳の明細書',
            de: 'Japanisch übersetzte Beschreibung',
        },
    },
];

export const LOGIC_FIELDS = [{
    name: LOGIC_OPERATOR_OR,
    value: 'OR ',
    labelPlaceholder: '',
    desc: {
        en: 'E.g. solar OR wind',
        cn: '例：太阳能 OR 风能',
        tw: '例：太阳能 OR 风能',
        jp: '例: 携帯端末 OR 携帯電話',
        de: 'z.B: Sonnen- OR Windenergie',
    },
},
{
    name: LOGIC_OPERATOR_AND,
    value: 'AND ',
    labelPlaceholder: '',
    desc: {
        en: 'E.g. solar AND cell',
        cn: '例：太阳能 AND 风能',
        tw: '例：太阳能 AND 风能',
        jp: '例: 自動 AND 販売機',
        de: 'z.B: Sonnen- AND Windenergie',
    },
},
{
    name: LOGIC_OPERATOR_NOT,
    value: 'NOT ',
    labelPlaceholder: '',
    desc: {
        en: 'E.g. solar NOT wind',
        cn: '例：太阳能 NOT 风能',
        tw: 'E.g. solar NOT wind',
        jp: 'E.g. solar NOT wind',
        de: 'z.B: solar NOT wind',
    },
},
];

export const DEFAULT_FIELDS = {
    cn: ['TAC', 'TA', 'DESC', 'CLMS', 'ANC', 'IN', 'IPC', 'PBD'],
    default: ['TAC', 'TA', 'DESC', 'CLMS', 'ANCS'],
    other: [
        ...DEFAULT_KEYWORD_FIELDS,
        ...DEFAULT_CLASSIFICATION_NUMBER_FIELDS,
        ...DEFAULT_ASSIGNEE_FIELDS,
        ...DEFAULT_OTHER_FIELDS,
    ],
};

export const ANALYSIS_FIELDS = [{
    name: 'AN_FACET_CN',
}, {
    name: 'AN_FACET',
}, {
    name: 'ANC_FACET',
}, {
    name: 'APN',
}, {
    name: 'IN_FACET',
}, {
    name: 'IPC_FACET',
}, {
    name: 'IPC_MAIN_GROUP',
}, {
    name: 'AN_ST_FACET',
}, {
    name: 'AN_ST',
}, {
    name: 'COUNTRY',
}, {
    name: 'CPC_FACET',
}, {
    name: 'CPC_MAIN_GROUP',
}, {
    name: 'GBC_FACET',
}, {
    name: 'GBC_DIVISION',
}, {
    name: 'GBC_GROUP',
}, {
    name: 'LOC_CLASS',
}, {
    name: 'LOC_FACET',
}, {
    name: 'UPC_FACET',
}, {
    name: 'UPC_CLASS',
}, {
    name: 'LEGAL_EVENT',
}, {
    name: 'ATC_CN_FACET',
}, {
    name: 'INS_FACET',
}, {
    name: 'ATC_FACET',
}, {
    name: 'AN_ADDRESS',
}, {
    name: 'AN_COUNTRY',
}, {
    name: 'AN_PROVINCE',
}, {
    name: 'F_AN',
}, {
    name: 'ANS_TYPE',
}, {
    name: 'INS',
}, {
    name: 'TRANSFER_BEFORE',
}, {
    name: 'TRANSFER_AFTER',
}, {
    name: 'IN_ADD',
}, {
    name: 'DOCUMENT_TYPE',
}, {
    name: 'INCHI_TITLE',
}, {
    name: 'INCHI_ABST',
}, {
    name: 'INCHI_CLAIMS',
}, {
    name: 'INCHI_DESC',
}, {
    name: 'INCHI_TAC',
}, {
    name: 'INCHI_ALL',
}, {
    name: 'POLYMER',
}, {
    name: 'SEQ_ID',
}, {
    name: 'LS',
}, {
    name: 'TRIAL_GRADE_CN',
}, {
    name: 'EXCLUSIVITY_CN',
}, {
    name: 'TRANS_EFDT',
}, {
    name: 'TYPE',
}, {
    name: 'RIDTP_CN',
}, {
    name: 'LITIGATION_COUNTRY',
}, {
    name: 'ANCS_FACET',
}, {
    name: 'RD_STATUS',
}, {
    name: 'RD_ABANDON',
}, {
    name: 'PV_VA',
}, {
    name: 'PV_ED',
}, {
    name: 'SEQ_CLAIMS_ID',
}, {
    name: 'AN_ADD',
}, {
    name: 'ICL_FACET',
}, {
    name: 'PBDT_YEAR',
}, {
    name: 'ANS_ID',
}, {
    name: 'ANC_BEFORE_FACET',
}, {
    name: 'CPC_SUB_GROUP',
}, {
    name: 'IPC_SUB_GROUP',
}, {
    name: 'ANC_AFTER_FACET',
}, {
    name: 'CREATE_TS',
}, {
    name: 'AT_CN_FACET',
}, {
    name: 'AT_FACET',
}, {
    name: 'MIPC_MAIN_GROUP',
}, {
    name: 'MIPC_FACET',
}, {
    name: 'FADL_COUNTRY',
}, {
    name: 'LIT_FILEDT',
}, {
    name: 'PRESIDING_EXAMINER',
}, {
    name: 'JUROR',
}, {
    name: 'PANEL_LEADER',
}, {
    name: 'RISUM',
}, {
    name: 'RIGR',
}, {
    name: 'RIFD',
}, {
    name: 'ISD_Y',
}, {
    name: 'FIRST_FADL_COUNTRY',
}, {
    name: 'PN_STR',
}, {
    name: 'APNO_FACET',
}, {
    name: 'YEARS_PENDENCY',
}, {
    name: 'AN_ENTRANS',
}, {
    name: 'AN_CNTRANS',
}, {
    name: 'PLE_TYPE',
}, {
    name: 'CLAIM_TYPE',
}, {
    name: 'CITE_COUNTRY',
}, {
    name: 'CITEDBY_COUNTRY',
}, {
    name: 'FIRST_AN',
}, {
    name: 'FIRST_ANC',
}, {
    name: 'FIRST_IN',
}, {
    name: 'COURT_FACET',
}, {
    name: 'AGENT_COMPANY',
}, {
    name: 'TRANSFER_EFDT_YEAR',
}, {
    name: 'EFFECTIVE_YEAR',
}, {
    name: 'PL_EFDT_YEAR',
}, {
    name: 'FADL_YEAR',
}, {
    name: 'LEGAL_YEAR',
}, {
    name: 'FILING_YEAR',
}, {
    name: 'LICENSE_TYPE',
}, {
    name: 'DESIGNATED_INDICATOR_STATE',
}, {
    name: 'ATC_S_FACET',
}, {
    name: 'CASE_REGION_FACET',
}, {
    name: 'TRANSFER_BEFORE_AFTER_RELATION',
}, {
    name: 'TRANSFER_AFTER_BEFORE_RELATION',
},

{
    name: 'PLAINTIFF_NNAME',
}, {
    name: 'DEFENDANT_NNAME',
}, {
    name: 'THIRD_PARTY',
}, {
    name: 'PLAINTIFF_AGENT_COMPANY',
}, {
    name: 'DEFENDANT_AGENT_COMPANY',
}, {
    name: 'THIRD_PARTY_AGENT',
}, {
    name: 'THIRD_PARTY_AGENT_COMPANY',
}, {
    name: 'COURTING_DATE',
}, {
    name: 'TECH_INVESTIGATOR',
}, {
    name: 'PLAINTIFF_NAME',
}, {
    name: 'JUDGE_ASSISTANT',
}, {
    name: 'DAMAGES_AMOUNT_COURT',
}, {
    name: 'AMOUNT_COURT',
}, {
    name: 'PLAINTIFF_AGENT',
}, {
    name: 'AMOUNT_CALCULATE',
}, {
    name: 'COST_AMOUNT_COURT',
}, {
    name: 'DAMAGES_AMOUNT_PLAINTIFF',
}, {
    name: 'COST_AMOUNT_PLAINTIFF',
}, {
    name: 'DISPUTE_FOCUS',
}, {
    name: 'RELATED_APPEAL',
}, {
    name: 'DEFENDANT_NAME',
}, {
    name: 'LEGAL_GROUND',
}, {
    name: 'DEFENDANT_AGENT',
}, {
    name: 'OUTCOME_TYPE',
}, {
    name: 'VERDICT_CAUSE',
}, {
    name: 'CLERK',
}, {
    name: 'VERDICT_CAUSE_SUM',
},
];

export const DEFAULT_SYNTAX_VALUES = {
    AUTHORITY: ['CN', 'US', 'GB', 'WO', 'EP', 'FR', 'DE', 'CH', 'JP'],
    CASE_REGION: ['北京', '上海', '广东', '江苏', '浙江'],
};
export const RANGE_SAMPLE = [{
    name: '[1 TO 50000]',
    value: '',
}, {
    name: '1000',
    value: '',
}];

export const RANGE_SAMPLE_SHORT = [{
    name: '[1 TO 10]',
    value: '',
}, {
    name: '5',
    value: '',
}];
export const DATE_SAMPLE = [{
    name: '[2010 TO 2020]',
    value: '',
}, {
    name: '[201012 TO 202012]',
    value: '',
}, {
    name: '[20101226 TO *]',
    value: '',
}, {
    name: '20151226',
    value: '',
}];

export const DATE_Y_SAMPLE = [{
    name: '[1893 TO 2020]',
    value: '',
}, {
    name: '2015',
    value: '',
}];
export const DATE_YM_SAMPLE = [{
    name: '[189312 TO 202012]',
    value: '',
}, {
    name: '201512',
    value: '',
}];

// 临时方案，后期会删掉，找其他比较好的方案
export function getSearchFieldsByServiceArea(serviceArea) {
    // eslint-disable-next-line no-param-reassign
    serviceArea = serviceArea || get(window, 'zPREFACE.accountInfo.site_region', '').toLowerCase();
    let searchFields = SEARCH_FIELDS;
    if (serviceArea === 'us' || serviceArea === 'eu') {
        searchFields = searchFields.concat(SEARCH_FIELDS_US);
    }
    searchFields = searchFields.concat(searchFieldsService.searchFields);
    return searchFields;
}

export default {
    SEARCH_FIELDS,
    SEARCH_FIELDS_US,
    LOGIC_FIELDS,
    ANALYSIS_FIELDS,
    DEFAULT_FIELDS,
    DEFAULT_SYNTAX_VALUES,
    RANGE_SAMPLE,
    RANGE_SAMPLE_SHORT,
    DATE_SAMPLE,
    DATE_Y_SAMPLE,
    DATE_YM_SAMPLE,
    getSearchFieldsByServiceArea,
};
